import { useState, useEffect } from 'react';

const CONTACT_PHONE = '470-756-9942';
const CONTACT_PHONE_HREF = 'tel:4707569942';
const CONTACT_EMAIL = 'kelly@fmacrew.com';
const CONTACT_NAME = 'Kelly Lee 실장';

const HERO_IMG = "https://public.readdy.ai/ai/img_res/edited_5316633d929089db1b54052bf8a1da37_bb5e3957.jpg";

const SERVICES_RESI = [
  { icon: 'ri-home-gear-line', title: '주방 & 욕실 리모델링', desc: '공간의 핵심인 주방과 욕실을 완전히 새롭게. 캐비닛, 상판, 타일, 조명, 설비까지 처음부터 끝까지 시공합니다.' },
  { icon: 'ri-paint-brush-line', title: '인테리어 리노베이션', desc: '거실, 침실, 다이닝 공간 등 실내 전반을 현대적으로 리노베이션. 바닥재, 도장, 조명, 마감재를 통한 공간 재탄생.' },
  { icon: 'ri-layout-4-line', title: '바닥재 & 타일 시공', desc: '하드우드, LVP, 타일, 대리석 등 모든 바닥재 시공 및 교체. 기초부터 완벽하게 마감합니다.' },
  { icon: 'ri-brush-line', title: '도장 & 마감', desc: '실내외 도장, 크라운 몰딩, 베이스보드 등 세밀한 마감 작업으로 공간의 완성도를 높입니다.' },
  { icon: 'ri-building-line', title: '지하실 마감', desc: '미활용 지하 공간을 홈 오피스, 게임룸, 추가 거실 등 실용적인 공간으로 변환합니다.' },
  { icon: 'ri-add-box-line', title: '공간 확장 & 증축', desc: '가족의 성장에 맞게 방을 추가하거나 기존 공간을 확장. 허가 취득부터 최종 마감까지 모두 처리합니다.' },
];

const SERVICES_COMM = [
  { icon: 'ri-store-line', title: '사무실 & 소매점 공사', desc: '사무실 레이아웃 변경, 리셉션 공사, 소매점 인테리어 공사까지 비즈니스 환경에 맞는 최적의 공간을 만듭니다.' },
  { icon: 'ri-building-4-line', title: '임차인 개선 (TI)', desc: 'TI 예산 관리, 임대인 승인 조율, 임대 사양 준수까지 임차인 개선 프로젝트 전 과정을 담당합니다.' },
  { icon: 'ri-wheelchair-line', title: 'ADA 규정 준수 공사', desc: '장애인 편의시설 설치, 출입구 확장, 경사로 공사 등 ADA 기준을 충족하는 상업 공간 개선.' },
  { icon: 'ri-organization-chart', title: '구조 변경', desc: '파티션 철거·설치, 공간 재배치, 개방형 레이아웃 전환 등 비즈니스 요구에 맞는 구조적 변경.' },
  { icon: 'ri-drop-line', title: '화장실 & 휴게실 개선', desc: '상업용 화장실 리모델링, 직원 휴게실 업그레이드, 위생 시설 현대화로 업무 환경을 향상시킵니다.' },
  { icon: 'ri-paint-brush-2-line', title: '상업 도장 & 마감', desc: '대규모 상업 공간의 실내외 도장, 에폭시 바닥, 특수 마감 처리로 브랜드 이미지를 강화합니다.' },
];

const WHY_ITEMS = [
  { icon: 'ri-shield-check-line', title: '면허 취득 · 보험 완비', desc: '조지아 주 면허를 보유한 정식 업체로 모든 현장에 종합 책임보험이 적용됩니다. 고객의 안심을 최우선으로 합니다.' },
  { icon: 'ri-time-line', title: '일정 & 예산 100% 준수', desc: '착공 전 명확한 공정표와 예산을 제시하고 그대로 지킵니다. 추가 비용 없이, 약속대로 완료합니다.' },
  { icon: 'ri-customer-service-2-line', title: '전담 담당자 배정', desc: '모든 고객에게 전담 담당자를 배정해 공사 전 기간 동안 언제든 빠르게 소통할 수 있습니다.' },
  { icon: 'ri-file-user-line', title: '허가 & 검사 일괄 처리', desc: '필요한 모든 허가를 직접 취득하고 검사 일정도 관리합니다. 고객이 시청에 따로 연락할 필요가 없습니다.' },
  { icon: 'ri-thumb-up-line', title: '1년 하자 보증', desc: '모든 시공에 1년 하자 보증을 제공합니다. 고객이 만족할 때까지 완료하지 않으며, 보증 기간 내 무상 처리합니다.' },
  { icon: 'ri-trophy-line', title: '최고 수준의 시공 품질', desc: '모든 작업을 내부 최고 기준으로 진행합니다. 빠르게 끝내는 것보다 완벽하게 끝내는 것을 추구합니다.' },
];

const TESTIMONIALS = [
  {
    name: 'James B.',
    role: '건물 관리자 · Norcross, GA',
    text: '아파트 외벽에서 수분 침투가 발견된 후 FMA Crew에 긴급 파사드 보수를 맡겼습니다. 몇 시간 만에 출동해 문제를 정확히 진단하고 방수·조적 보수를 예상보다 빠르게 마무리했습니다. 군더더기 없이 깔끔하고 전문적이었습니다.',
    service: '리모델링 & 유지보수',
    initials: 'JB',
  },
  {
    name: 'Karen P.',
    role: '건물 소유주 · Marietta, GA',
    text: '건물 4개 동 전체의 구조 콘크리트 보수와 외부 재실링을 맡겼습니다. 팀이 체계적으로 움직였고 매 단계마다 명확하게 소통해 주었습니다. 결과물은 새것 이상이었고, 바로 예방 유지보수 계약까지 연장했습니다.',
    service: '건물·시설 유지보수',
    initials: 'KP',
  },
  {
    name: 'Robert T.',
    role: 'HOA 이사장 · Decatur, GA',
    text: '80세대 이상의 발코니 방수 공사를 의뢰했습니다. 단계별로 진행해 입주민들이 불편을 최소화할 수 있도록 배려해 주었습니다. 품질이 탁월했고 일정과 예산 모두 정확히 지켜졌습니다.',
    service: 'HOA 공사 · 80세대 이상',
    initials: 'RT',
  },
];

const PROCESS = [
  { step: '01', title: '무료 현장 방문 견적', desc: '전문가가 직접 현장을 방문하여 꼼꼼히 확인한 후 24시간 이내에 상세한 무료 견적을 제공합니다. 숨겨진 비용 없이 명확하게 안내합니다.' },
  { step: '02', title: '공사 범위 확정 & 일정 수립', desc: '공사 범위, 일정, 자재, 단계별 계획을 명확히 제시합니다. 고객이 승인하면 바로 일정을 잡습니다.' },
  { step: '03', title: '전문가 시공', desc: '면허 취득 팀이 정밀하게 시공합니다. 공사 진행 상황을 정기적으로 업데이트하여 항상 현황을 파악할 수 있습니다.' },
  { step: '04', title: '최종 점검 & 사인오프', desc: '준공 전 고객과 함께 전 공정을 직접 점검합니다. 미비한 부분이 있으면 추가 비용 없이 완벽하게 마무리합니다.' },
];

export default function BrochureSrp02() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [activeTab, setActiveTab] = useState<'resi' | 'comm'>('resi');
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (message.length > 500) return;
    setFormStatus('loading');
    try {
      const form = e.currentTarget;
      const raw = new FormData(form);
      const data = new URLSearchParams();
      raw.forEach((value, key) => data.append(key, value.toString()));
      const res = await fetch('https://readdy.ai/api/form/d70utgj2m2156g4s7450', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setFormStatus(res.ok ? 'success' : 'error');
    } catch {
      setFormStatus('error');
    }
  };

  return (
    <>
      <meta name="robots" content="noindex, nofollow" />
      <div className="min-h-screen bg-white font-sans">
        {/* Header */}
        <header className="bg-[#7C3AED] px-5 md:px-10 py-4 flex items-center justify-between sticky top-0 z-50">
          <div className="flex items-center">
            <div className="h-10 flex items-center">
              <img
                src="https://storage.readdy-site.link/project_files/a1db2c25-97e2-4ceb-a4ec-c06941f029b5/a3ac0cdf-0792-4180-b72e-0df4bd1c7c5e_FMA-CREW-LOGO.png?v=b37410eb2aa41c47106263f8d4f50ddf"
                alt="FMA Crew - Facility Maintenance of America"
                className="h-full w-auto object-contain brightness-0 invert"
              />
            </div>
          </div>
          <a
            href={CONTACT_PHONE_HREF}
            className="flex items-center gap-2 bg-white text-[#7C3AED] px-4 py-2 rounded-md text-xs font-bold whitespace-nowrap cursor-pointer hover:bg-purple-50 transition-colors"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill" />
            </div>
            {CONTACT_PHONE}
          </a>
        </header>

        {/* Hero */}
        <section className="relative overflow-hidden" style={{ minHeight: '520px' }}>
          <img
            src={HERO_IMG}
            alt="주거·상업 리모델링"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/50" />
          <div className="relative z-10 px-5 md:px-12 py-14 md:py-20 max-w-3xl">
            <div className="inline-flex items-center gap-2 bg-[#7C3AED]/25 border border-[#A78BFA]/50 px-3 py-1.5 rounded-full mb-5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-hammer-line text-[#C4B5FD] text-xs" />
              </div>
              <span className="text-[#C4B5FD] text-xs tracking-widest uppercase font-semibold">인테리어 리모델링 전문</span>
            </div>
            <h1 className="text-white text-3xl md:text-5xl font-bold leading-tight mb-4">
              주거·상업 공간<br />
              <span className="text-[#C4B5FD]">리모델링</span>
            </h1>
            <p className="text-white/85 text-base md:text-lg leading-relaxed mb-3 max-w-xl">
              기획부터 완공까지 한 팀이 책임집니다
            </p>
            <p className="text-white/75 text-sm md:text-base leading-relaxed mb-4 max-w-2xl">
              주방·욕실 리모델링부터 상업 공간 전체 리노베이션까지 — 허가, 시공, 마감의 모든 과정을 한 팀에서 처리합니다. 여러 업체를 따로 관리할 필요가 없습니다.
            </p>
            <p className="text-white/65 text-sm leading-relaxed mb-6 max-w-2xl">
              애틀란타 광역권(Norcross · Marietta · Alpharetta · Decatur · Roswell 및 반경 50마일)의 주거·상업 고객을 전담합니다.
            </p>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 flex items-center justify-center bg-[#7C3AED]/25 rounded-full border border-[#A78BFA]/50">
                <i className="ri-user-line text-[#C4B5FD] text-sm" />
              </div>
              <p className="text-[#C4B5FD] text-sm font-semibold">담당: {CONTACT_NAME}</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href={CONTACT_PHONE_HREF}
                className="flex items-center justify-center gap-2 bg-[#7C3AED] text-white px-6 py-3.5 rounded-md text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-[#6D28D9] transition-colors"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill" />
                </div>
                전화 상담: {CONTACT_PHONE}
              </a>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="flex items-center justify-center gap-2 bg-white/15 border border-white/35 text-white px-6 py-3.5 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-white/25 transition-colors"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line" />
                </div>
                {CONTACT_EMAIL}
              </a>
            </div>
          </div>
        </section>

        {/* Stats Bar */}
        <section className="bg-[#EDE9FE] px-5 md:px-10 py-5">
          <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {[
              { icon: 'ri-award-line', value: 'GA 면허', label: '조지아 주 면허 · 보험 완비' },
              { icon: 'ri-team-line', value: '10년+', label: '팀 현장 시공 경력' },
              { icon: 'ri-calendar-check-line', value: '1년 보증', label: '전 시공 하자 보증 제공' },
              { icon: 'ri-thumb-up-line', value: '100%', label: '고객 만족도 목표' },
            ].map((stat) => (
              <div key={stat.label} className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center bg-[#7C3AED]/15 text-[#7C3AED] rounded shrink-0">
                  <i className={`${stat.icon} text-base`} />
                </div>
                <div>
                  <p className="text-[#5B21B6] font-bold text-sm md:text-base leading-tight">{stat.value}</p>
                  <p className="text-[#7C3AED]/65 text-xs leading-tight">{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* About Section */}
        <section className="bg-white px-5 md:px-10 py-12 md:py-16">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div>
                <span className="text-[#7C3AED] text-xs tracking-widest uppercase font-semibold">FMA Crew 소개</span>
                <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mt-3 mb-4 leading-tight">
                  유지보수와 건설의<br />
                  <span className="text-[#5B21B6]">든든한 파트너</span>
                </h2>
                <div className="w-10 h-0.5 bg-[#7C3AED] mb-5" />
                <p className="text-slate-600 text-sm md:text-base leading-relaxed mb-4">
                  <strong>FMA Crew — Facility Maintenance of America</strong> — 는 애틀란타 광역권의 주거·상업 건물을 위한 종합 유지보수 및 리모델링 전문 회사입니다.
                </p>
                <p className="text-slate-600 text-sm md:text-base leading-relaxed mb-4">
                  구조 보수, 인테리어 리노베이션, 상업 공사, 예방 유지보수 프로그램까지 — 풍부한 현장 경험을 가진 전문가 팀이 모든 프로젝트를 처음부터 끝까지 책임집니다.
                </p>
                <p className="text-slate-600 text-sm md:text-base leading-relaxed">
                  여러 업체를 따로 관리하는 번거로움 없이, <strong>한 팀에서 시설 유지보수부터 전체 건설 공사까지 모두 처리</strong>해 드립니다.
                </p>
              </div>
              <div className="relative">
                <div className="overflow-hidden h-[280px] md:h-[380px] w-full rounded-lg">
                  <img
                    src="https://public.readdy.ai/ai/img_res/97b4f41a18f27446c7629ed05290b242.jpg"
                    alt="리모델링 시공 품질"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -bottom-4 -right-2 md:-bottom-5 md:-right-4 text-white p-4 w-40 rounded-xl" style={{ background: 'linear-gradient(135deg, #6D28D9 0%, #7C3AED 55%, #A78BFA 100%)' }}>
                  <div className="w-7 h-7 flex items-center justify-center bg-white/20 mb-2">
                    <i className="ri-medal-line text-base" />
                  </div>
                  <p className="text-sm font-bold leading-tight">Excellence First</p>
                  <p className="text-white/80 text-xs mt-1 leading-snug">고객 만족 최우선</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services */}
        <section className="bg-[#FAF5FF] px-5 md:px-10 py-12 md:py-16">
          <div className="max-w-5xl mx-auto">
            <div className="mb-6 md:mb-8">
              <span className="text-[#7C3AED] text-xs tracking-widest uppercase font-semibold">서비스 안내</span>
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mt-3">
                주거·상업 리모델링 — <span className="text-[#5B21B6]">전 분야 커버</span>
              </h2>
              <p className="text-slate-500 text-sm md:text-base mt-2 max-w-2xl leading-relaxed">
                주방·욕실 리모델링부터 상업 공간 전체 공사까지 — 리모델링에 필요한 모든 것을 한 팀에서 해결하세요.
              </p>
            </div>

            <div className="flex gap-2 p-1.5 bg-white border border-purple-100 w-fit rounded-lg mb-6">
              <button
                onClick={() => setActiveTab('resi')}
                className={`flex items-center gap-2 px-4 py-2 rounded-md text-xs font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${activeTab === 'resi' ? 'bg-[#7C3AED] text-white' : 'text-slate-500 hover:text-slate-800'}`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-home-heart-line text-sm" />
                </div>
                주거 리모델링
              </button>
              <button
                onClick={() => setActiveTab('comm')}
                className={`flex items-center gap-2 px-4 py-2 rounded-md text-xs font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${activeTab === 'comm' ? 'bg-[#7C3AED] text-white' : 'text-slate-500 hover:text-slate-800'}`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-store-2-line text-sm" />
                </div>
                상업 리모델링
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {(activeTab === 'resi' ? SERVICES_RESI : SERVICES_COMM).map((svc) => (
                <div key={svc.title} className="bg-white border border-purple-100 p-5 hover:border-[#7C3AED] transition-all duration-200 rounded-lg">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#EDE9FE] text-[#7C3AED] rounded mb-3">
                    <i className={`${svc.icon} text-lg`} />
                  </div>
                  <h3 className="text-slate-900 font-bold text-sm mb-2">{svc.title}</h3>
                  <p className="text-slate-500 text-xs leading-relaxed">{svc.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 p-5 bg-[#7C3AED] rounded-lg">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <div>
                  <p className="text-white font-bold text-base">맞춤형 리모델링 견적이 필요하신가요?</p>
                  <p className="text-purple-200 text-sm mt-1">주거·상업 리모델링 모두 무료 현장 방문 후 24시간 이내에 상세 견적을 제공합니다.</p>
                </div>
                <a
                  href={CONTACT_PHONE_HREF}
                  className="flex items-center gap-2 bg-white text-[#7C3AED] px-5 py-3 rounded-md text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-purple-50 transition-colors shrink-0"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-fill" />
                  </div>
                  무료 견적 받기
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Service Area Map */}
        <section className="bg-[#FAF5FF] px-5 md:px-10 py-12 md:py-16">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div>
                <span className="text-[#7C3AED] text-xs tracking-widest uppercase font-semibold">서비스 지역</span>
                <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mt-3 mb-4 leading-tight">
                  애틀란타 광역권<br />
                  <span className="text-[#5B21B6]">전 지역 서비스</span>
                </h2>
                <div className="w-10 h-0.5 bg-[#7C3AED] mb-5" />
                <p className="text-slate-600 text-sm leading-relaxed mb-5">
                  애틀란타 광역권 전역에 팀이 배치되어 있어 빠른 대응이 가능합니다. 반경 50마일 이내 모든 지역을 커버합니다.
                </p>
                <div className="grid grid-cols-2 gap-2">
                  {['Norcross', 'Marietta', 'Alpharetta', 'Decatur', 'Roswell', 'Sandy Springs', 'Duluth', 'Lawrenceville'].map((city) => (
                    <div key={city} className="flex items-center gap-2">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-map-pin-2-fill text-[#7C3AED] text-xs" />
                      </div>
                      <span className="text-slate-700 text-sm">{city}</span>
                    </div>
                  ))}
                </div>
                <p className="text-slate-500 text-xs mt-4">+ 반경 50마일 이내 애틀란타 광역권 전체</p>
              </div>
              <div className="rounded-xl overflow-hidden border border-purple-100 h-[320px] md:h-[380px]">
                <iframe
                  title="FMA Crew 서비스 지역 - 애틀란타 광역권"
                  src="https://maps.google.com/maps?q=Atlanta,Georgia,USA&z=9&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose FMA */}
        <section className="bg-[#F5F3FF] px-5 md:px-10 py-12 md:py-16">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <span className="text-[#7C3AED] text-xs tracking-widest uppercase font-semibold">선택 이유</span>
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mt-3">
                FMA Crew가 <span className="text-[#7C3AED]">다른 점</span>
              </h2>
              <p className="text-slate-500 text-sm md:text-base mt-3 max-w-xl mx-auto leading-relaxed">
                전문성, 투명한 소통, 그리고 결과로 증명합니다.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {WHY_ITEMS.map((item) => (
                <div key={item.title} className="bg-white border border-purple-100 p-5 rounded-xl hover:border-[#7C3AED]/50 transition-colors">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#EDE9FE] text-[#7C3AED] rounded mb-3">
                    <i className={`${item.icon} text-lg`} />
                  </div>
                  <h3 className="text-slate-900 font-bold text-sm mb-2">{item.title}</h3>
                  <p className="text-slate-600 text-xs leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Process */}
        <section className="bg-white px-5 md:px-10 py-12 md:py-16">
          <div className="max-w-5xl mx-auto">
            <div className="mb-8 md:mb-10">
              <span className="text-[#7C3AED] text-xs tracking-widest uppercase font-semibold">진행 과정</span>
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mt-3">
                단순한 프로세스. <span className="text-[#5B21B6]">놀라운 결과.</span>
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {PROCESS.map((p) => (
                <div key={p.step} className="flex gap-4 p-5 bg-[#FAF5FF] border border-purple-100 rounded-lg">
                  <div className="shrink-0">
                    <span className="text-2xl font-black text-[#7C3AED] leading-none">{p.step}</span>
                  </div>
                  <div>
                    <h3 className="text-slate-900 font-bold text-sm mb-1.5">{p.title}</h3>
                    <p className="text-slate-500 text-xs leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="bg-[#FAF5FF] px-5 md:px-10 py-12 md:py-16">
          <div className="max-w-5xl mx-auto">
            <div className="mb-8">
              <span className="text-[#7C3AED] text-xs tracking-widest uppercase font-semibold">고객 후기</span>
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mt-3">
                고객이 직접 말하는 FMA Crew
              </h2>
            </div>

            <div className="bg-white border border-purple-100 rounded-lg p-6 md:p-8 mb-4">
              <div className="flex gap-1 mb-4">
                {[1,2,3,4,5].map((s) => (
                  <div key={s} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-sm" />
                  </div>
                ))}
              </div>
              <p className="text-slate-700 text-sm md:text-base leading-relaxed mb-5 italic">
                &ldquo;{TESTIMONIALS[activeTestimonial].text}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#7C3AED] text-white rounded-full text-xs font-bold shrink-0">
                  {TESTIMONIALS[activeTestimonial].initials}
                </div>
                <div>
                  <p className="text-slate-900 font-bold text-sm">{TESTIMONIALS[activeTestimonial].name}</p>
                  <p className="text-slate-500 text-xs">{TESTIMONIALS[activeTestimonial].role}</p>
                </div>
                <div className="ml-auto">
                  <span className="px-3 py-1 bg-[#EDE9FE] text-[#7C3AED] text-xs font-semibold rounded-full">
                    {TESTIMONIALS[activeTestimonial].service}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex gap-2">
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActiveTestimonial(i)}
                  className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${activeTestimonial === i ? 'w-6 bg-[#7C3AED]' : 'w-2 bg-slate-300'}`}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Inquiry Form */}
        <section className="bg-white px-5 md:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-8">
              <span className="text-[#7C3AED] text-xs tracking-widest uppercase font-semibold">무료 견적 문의</span>
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mt-3">지금 바로 문의하세요</h2>
              <p className="text-slate-500 text-sm mt-2 max-w-lg mx-auto">담당자 <strong>{CONTACT_NAME}</strong>이 24시간 이내에 직접 연락드립니다. 조건 없이, 비용 없이.</p>
            </div>

            {formStatus === 'success' ? (
              <div className="bg-[#EDE9FE] border border-purple-200 rounded-lg p-10 text-center">
                <div className="w-14 h-14 flex items-center justify-center bg-[#7C3AED] text-white rounded-full mx-auto mb-4">
                  <i className="ri-check-line text-2xl" />
                </div>
                <h3 className="text-slate-900 font-bold text-lg mb-2">문의가 접수되었습니다!</h3>
                <p className="text-slate-600 text-sm">24시간 이내에 {CONTACT_NAME}이 연락드리겠습니다.</p>
              </div>
            ) : (
              <form
                data-readdy-form
                id="srp02-inquiry-form"
                onSubmit={handleFormSubmit}
                className="bg-[#FAF5FF] border border-purple-100 rounded-lg p-6 md:p-8"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-slate-700 text-xs font-semibold mb-1.5">성함 <span className="text-[#7C3AED]">*</span></label>
                    <input
                      type="text"
                      name="name"
                      required
                      placeholder="홍길동"
                      className="w-full border border-purple-100 bg-white rounded-md px-3 py-2.5 text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:border-[#7C3AED] transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-slate-700 text-xs font-semibold mb-1.5">이메일 <span className="text-[#7C3AED]">*</span></label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="example@email.com"
                      className="w-full border border-purple-100 bg-white rounded-md px-3 py-2.5 text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:border-[#7C3AED] transition-colors"
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <label className="block text-slate-700 text-xs font-semibold mb-1.5">연락처</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="(000) 000-0000"
                    className="w-full border border-purple-100 bg-white rounded-md px-3 py-2.5 text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:border-[#7C3AED] transition-colors"
                  />
                </div>
                <div className="mb-5">
                  <label className="block text-slate-700 text-xs font-semibold mb-1.5">문의 내용 <span className="text-[#7C3AED]">*</span></label>
                  <textarea
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    placeholder="공사 종류, 공간 규모, 희망 일정 등 간단히 적어주세요..."
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                    className="w-full border border-purple-100 bg-white rounded-md px-3 py-2.5 text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:border-[#7C3AED] transition-colors resize-none"
                  />
                  <p className="text-xs text-slate-400 text-right mt-1">{message.length}/500</p>
                </div>
                {formStatus === 'error' && (
                  <p className="text-red-500 text-xs mb-3">제출 중 오류가 발생했습니다. 전화로 직접 문의해 주세요.</p>
                )}
                <button
                  type="submit"
                  disabled={formStatus === 'loading'}
                  className="w-full bg-[#7C3AED] text-white py-3 rounded-md text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-[#6D28D9] transition-colors disabled:opacity-60"
                >
                  {formStatus === 'loading' ? '전송 중...' : '무료 견적 문의 보내기'}
                </button>
              </form>
            )}
          </div>
        </section>

        {/* CTA Footer */}
        <section className="bg-[#7C3AED] px-5 md:px-10 py-12 md:py-16">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight">
                공간을 새롭게 바꿀 준비가 되셨나요?
              </h2>
              <p className="text-purple-200 text-sm md:text-base mt-3 max-w-xl mx-auto leading-relaxed">
                부담 없이 연락주세요. 24시간 이내에 무료 견적을 드립니다 — 조건 없이, 비용 없이.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              <div className="flex items-center gap-3 p-4 bg-white/15 border border-white/25 rounded-lg">
                <div className="w-9 h-9 flex items-center justify-center bg-white/20 text-white rounded shrink-0">
                  <i className="ri-user-line text-base" />
                </div>
                <div>
                  <p className="text-purple-200 text-xs">담당자</p>
                  <p className="text-white font-semibold text-sm">{CONTACT_NAME}</p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 bg-white/15 border border-white/25 rounded-lg">
                <div className="w-9 h-9 flex items-center justify-center bg-white/20 text-white rounded shrink-0">
                  <i className="ri-phone-line text-base" />
                </div>
                <div>
                  <p className="text-purple-200 text-xs">전화번호</p>
                  <a href={CONTACT_PHONE_HREF} className="text-white font-semibold text-sm hover:text-purple-200 transition-colors cursor-pointer">{CONTACT_PHONE}</a>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 bg-white/15 border border-white/25 rounded-lg">
                <div className="w-9 h-9 flex items-center justify-center bg-white/20 text-white rounded shrink-0">
                  <i className="ri-mail-line text-base" />
                </div>
                <div>
                  <p className="text-purple-200 text-xs">이메일</p>
                  <a href={`mailto:${CONTACT_EMAIL}`} className="text-white font-semibold text-sm hover:text-purple-200 transition-colors cursor-pointer">{CONTACT_EMAIL}</a>
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href={CONTACT_PHONE_HREF}
                className="flex items-center justify-center gap-2 bg-white text-[#7C3AED] px-8 py-4 rounded-md text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-purple-50 transition-colors"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill" />
                </div>
                지금 전화로 무료 견적 받기
              </a>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="flex items-center justify-center gap-2 bg-white/15 border border-white/30 text-white px-8 py-4 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-white/25 transition-colors"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-send-line" />
                </div>
                이메일로 문의하기
              </a>
            </div>
          </div>
        </section>

        {/* Footer Strip */}
        <div className="bg-[#F5F3FF] border-t border-purple-100 px-5 py-4 text-center">
          <p className="text-[#7C3AED]/60 text-xs">© 2026 FMA Crew — Facility Maintenance of America. All rights reserved. · GA 면허 취득 · 보험 완비</p>
        </div>
      </div>
    </>
  );
}
